import type { RegionCode } from "brandRegionConfig";

export const i18nLocales = ["en", "fr", "es", "de-DE"] as const;
export type SupportedLocale = (typeof i18nLocales)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en";
export const ALL_VALUE = "ALL" as const;
export const EMPTY_VALUE = " - " as const;
export const ALL_SYMBOL = "*" as const;
export const MAX_MAX_RESULT_COUNT = 1000 as const;
export const BRAND_FILTER_QUERY_KEY = "brandFilter" as const;
export const REGION_FILTER_QUERY_KEY = "regionFilter" as const;
export const supportedCurrencies = [
  "USD",
  "EUR",
  "GBP",
  "CAD",
  "AUD",
  "JPY",
  "CNY",
  "NZD",
  "MXN",
] as const;

export const COUNTRY_ISO_CURRENCY_MAP: Record<RegionCode, SupportedCurrency> = {
  us: "USD",
  ca: "CAD",
  de: "EUR",
  au: "AUD",
  nz: "NZD",
  mx: "MXN",
};
export type SupportedCurrency = (typeof supportedCurrencies)[number];
